import { render, staticRenderFns } from "./ConfigHeader.vue?vue&type=template&id=61e43ce2&scoped=true&"
import script from "./ConfigHeader.vue?vue&type=script&lang=js&"
export * from "./ConfigHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConfigHeader.vue?vue&type=style&index=0&id=61e43ce2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e43ce2",
  null
  
)

export default component.exports